






import DefaultLayout from '@/layouts/DefaultLayout.vue';
import UrgentServiceLayout from '@/layouts/UrgentServiceLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';

window.$ = window.jQuery = require('jquery');
window.fn = require('owl.carousel');

export default {
  name: 'App',
  components: {
    DefaultLayout,
    UrgentServiceLayout,
    EmptyLayout,
  },
  computed: {
    currentLayout() {
      if (this.$route.name === 'UrgentService') {
        return UrgentServiceLayout;
      }
      if (this.$route.name === 'SearchCar') {
        return EmptyLayout;
      }
      return DefaultLayout;
    },
  },
  watch: {
    '$i18n.locale': {
      handler(newLocale: string) {
        console.log('Language changed to:', newLocale);
        const isVietnamese = newLocale === 'vi';
        console.log('Is Vietnamese:', isVietnamese);
        document.body.classList.toggle('vietnamese', isVietnamese);
        console.log('Body classes after toggle:', document.body.className);
      },
      immediate: true
    }
  },
  mounted() {
    // Ensure Vietnamese class is applied on mount
    console.log('App mounted, current locale:', this.$i18n.locale);
    const isVietnamese = this.$i18n.locale === 'vi';
    console.log('Is Vietnamese on mount:', isVietnamese);
    document.body.classList.toggle('vietnamese', isVietnamese);
    console.log('Body classes on mount:', document.body.className);
  }
};
